import React, { useMemo } from 'react'

import { ApolloProvider as ApolloHooksProvider, ApolloProvider } from '@apollo/client'
import { ThemeProvider } from '@mui/material'
import { IntlProvider } from 'react-intl'

import { Alert, theme, themeClarity } from '@acre/design-system'
import { applyScoreBranding, ErrorProvider, flattenMessages, getMessages, Locales, useFlag } from '@acre/utils'

import initApollo from './graphql/initApollo'
import messages from './intl/messagesIntroducers'
import { GlobalStyle } from './index.styles'

const flattenedMessages = flattenMessages(getMessages(messages, Locales.GB))

type Props = {
  children: JSX.Element
}

const AppProviders = ({ children }: Props) => {
  const client = useMemo(initApollo, [])
  const scoreFont = useFlag('feature.score_font', false)
  const isScoreRebrand = useFlag('feature.score_rebrand', false)
  const brandedMessages = useMemo(
    () => (isScoreRebrand ? applyScoreBranding(flattenedMessages) : flattenedMessages),
    [isScoreRebrand],
  )

  return (
    <ThemeProvider theme={scoreFont ? themeClarity : theme}>
      <IntlProvider locale={Locales.GB} messages={brandedMessages}>
        <ApolloProvider client={client}>
          <ApolloHooksProvider client={client}>
            <ErrorProvider alertSlot={Alert}>
              <GlobalStyle />
              {children}
            </ErrorProvider>
          </ApolloHooksProvider>
        </ApolloProvider>
      </IntlProvider>
    </ThemeProvider>
  )
}
export default AppProviders
